<template>
  <div class="welcome-dash">
    <!-- 欢迎横幅 -->
    <section class="welcome-hero">
      <div class="hero-text">
        <div class="hello">{{ helloText }}，{{ userName }} <span class="wave">👋</span></div>
        <h1>欢迎进入蔚动力智慧充电运营管理平台</h1>
        <p class="date">{{ todayText }} · 祝您工作愉快</p>
      </div>
      <div class="hero-pile">
        <svg viewBox="0 0 200 320" width="150" height="240">
          <defs>
            <linearGradient id="wBody" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stop-color="#163b50" />
              <stop offset="1" stop-color="#0a2230" />
            </linearGradient>
            <filter id="wGlow" x="-60%" y="-60%" width="220%" height="220%">
              <feGaussianBlur stdDeviation="4" result="b" />
              <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
            </filter>
          </defs>
          <rect x="50" y="20" width="100" height="270" rx="22" fill="url(#wBody)" stroke="#1d5b73" stroke-width="1.5" />
          <rect x="50" y="20" width="100" height="11" rx="5" fill="#00e5ff" style="filter: drop-shadow(0 0 6px #00e5ff)" />
          <rect x="66" y="54" width="68" height="104" rx="12" fill="#06202c" stroke="#114055" stroke-width="1.5" />
          <path class="w-bolt" d="M100 72 L80 124 L95 124 L88 148 L118 100 L100 100 Z" fill="#00ffa3" filter="url(#wGlow)" />
          <rect x="66" y="178" width="68" height="7" rx="3.5" fill="#0e2a38" />
          <rect class="w-bar" x="66" y="178" width="42" height="7" rx="3.5" fill="#00e5ff" />
          <circle cx="76" cy="200" r="3.5" fill="#00ffa3" />
          <circle cx="92" cy="200" r="3.5" fill="#00e5ff" />
          <circle cx="108" cy="200" r="3.5" fill="#1d5b73" />
          <rect x="40" y="290" width="120" height="12" rx="6" fill="#0a2230" stroke="#1d5b73" />
        </svg>
      </div>
    </section>

    <!-- KPI 卡片 -->
    <section class="kpi-row">
      <div class="kpi-card" v-for="(k, i) in kpis" :key="i">
        <div class="kpi-icon" :style="{ background: k.bg }">
          <svg viewBox="0 0 24 24" width="22" height="22">
            <path :d="k.icon" fill="#fff" />
          </svg>
        </div>
        <div class="kpi-body">
          <div class="kpi-value">{{ k.value }}<span class="unit">{{ k.unit }}</span></div>
          <div class="kpi-label">{{ k.label }}</div>
        </div>
        <div class="kpi-trend" :class="k.up ? 'up' : 'down'">
          <span class="arrow">{{ k.up ? '▲' : '▼' }}</span>{{ k.trend }}
        </div>
      </div>
    </section>

    <!-- 趋势图 -->
    <section class="panel trend-panel">
      <div class="panel-head">
        <h3>近 7 日充电量趋势</h3>
        <span class="panel-sub">单位：kWh</span>
      </div>
      <div ref="trendChart" class="chart"></div>
    </section>

    <!-- 底部双栏 -->
    <section class="bottom-row">
      <div class="panel">
        <div class="panel-head">
          <h3>充电类型分布</h3>
        </div>
        <div ref="typeChart" class="chart chart-sm"></div>
      </div>

      <div class="panel">
        <div class="panel-head">
          <h3>站点充电量 TOP5</h3>
          <span class="panel-sub">单位：kWh</span>
        </div>
        <div class="rank">
          <div class="rank-item" v-for="(r, i) in topStations" :key="i">
            <span class="rank-no" :class="{ top: i < 3 }">{{ i + 1 }}</span>
            <span class="rank-name">{{ r.name }}</span>
            <div class="rank-track">
              <div class="rank-fill" :style="{ width: r.pct + '%', background: r.color }"></div>
            </div>
            <span class="rank-val">{{ r.value }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 实时动态 -->
    <section class="panel">
      <div class="panel-head">
        <h3>实时充电动态</h3>
        <span class="live"><i></i>实时</span>
      </div>
      <ul class="feed">
        <li v-for="(f, i) in feed" :key="i">
          <span class="feed-dot" :style="{ background: f.color }"></span>
          <span class="feed-text">{{ f.text }}</span>
          <span class="feed-time">{{ f.time }}</span>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  data() {
    return {
      userName: localStorage.getItem('userName') || '管理员',
      helloText: '您好',
      todayText: '',
      kpis: [
        { label: '今日充电量', value: '12,860', unit: ' kWh', up: true, trend: '8.2%',
          bg: 'linear-gradient(135deg,#00e5ff,#00b4d8)', icon: 'M13 2 L4 14 H11 L9 22 L20 9 H13 Z' },
        { label: '今日订单数', value: '1,342', unit: ' 笔', up: true, trend: '5.1%',
          bg: 'linear-gradient(135deg,#00ffa3,#00c2a8)', icon: 'M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm2 5v2h10V8H7Zm0 4v2h10v-2H7Zm0 4v2h6v-2H7Z' },
        { label: '在线充电桩', value: '1,086', unit: ' /1200', up: true, trend: '1.4%',
          bg: 'linear-gradient(135deg,#4f9bff,#2f6bff)', icon: 'M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v9h16v-9a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5Zm3 8H9V7a3 3 0 0 1 6 0v3Z' },
        { label: '今日收益', value: '9,742', unit: ' 元', up: true, trend: '6.7%',
          bg: 'linear-gradient(135deg,#ffce3d,#ff9f1c)', icon: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm1 12h-2v-6h2v6Z' },
        { label: '充电利用率', value: '68.5', unit: ' %', up: true, trend: '3.2%',
          bg: 'linear-gradient(135deg,#a06bff,#7b3fff)', icon: 'M12 4a8 8 0 1 0 8 8h-2a6 6 0 1 1-6-6V4Zm0-2v4l3 2-3 2V6Z' },
        { label: '告警事件', value: '12', unit: ' 条', up: false, trend: '2 条',
          bg: 'linear-gradient(135deg,#ff7a7a,#ff4d4f)', icon: 'M12 2 2 21h20L12 2Zm0 6 1 7h-2l1-7Zm0 9.5a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6Z' }
      ],
      topStations: [
        { name: '滨江快充站', value: 1860, pct: 100, color: 'linear-gradient(90deg,#00e5ff,#00ffa3)' },
        { name: '高新枢纽站', value: 1520, pct: 82, color: 'linear-gradient(90deg,#00e5ff,#00ffa3)' },
        { name: '城东充电广场', value: 1280, pct: 69, color: 'linear-gradient(90deg,#4f9bff,#2f6bff)' },
        { name: '西站能源港', value: 980, pct: 53, color: 'linear-gradient(90deg,#4f9bff,#2f6bff)' },
        { name: '机场路超充站', value: 720, pct: 39, color: 'linear-gradient(90deg,#a06bff,#7b3fff)' }
      ],
      feed: [
        { text: '滨江快充站 #08 桩开始充电', time: '22:03', color: '#00ffa3' },
        { text: '高新枢纽站新增订单 ORD-20486', time: '22:01', color: '#00e5ff' },
        { text: '城东充电广场 #12 桩充电完成', time: '21:58', color: '#4f9bff' },
        { text: '西站能源港通讯中断已恢复', time: '21:52', color: '#ffce3d' },
        { text: '机场路超充站 #03 桩过载告警', time: '21:47', color: '#ff4d4f' }
      ],
      trendChart: null,
      typeChart: null
    }
  },
  mounted() {
    const h = new Date().getHours()
    this.helloText = h < 6 ? '凌晨好' : h < 12 ? '上午好' : h < 14 ? '中午好' : h < 18 ? '下午好' : '晚上好'
    const d = new Date()
    const week = ['日', '一', '二', '三', '四', '五', '六']
    this.todayText = `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 星期${week[d.getDay()]}`
    this.$nextTick(() => {
      this.initCharts()
      window.addEventListener('resize', this.resizeCharts)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCharts)
    if (this.trendChart) this.trendChart.dispose()
    if (this.typeChart) this.typeChart.dispose()
  },
  methods: {
    resizeCharts() {
      if (this.trendChart) this.trendChart.resize()
      if (this.typeChart) this.typeChart.resize()
    },
    initCharts() {
      const echarts = window.echarts
      if (!echarts) return
      // 趋势图
      this.trendChart = echarts.init(this.$refs.trendChart)
      const days = ['7-04', '7-05', '7-06', '7-07', '7-08', '7-09', '今日']
      const data = [9600, 10200, 8800, 11500, 12100, 10900, 12860]
      this.trendChart.setOption({
        grid: { left: 40, right: 20, top: 30, bottom: 30 },
        tooltip: { trigger: 'axis', backgroundColor: 'rgba(10,34,48,.9)', borderColor: '#1d5b73', textStyle: { color: '#fff' } },
        xAxis: { type: 'category', data: days, boundaryGap: false, axisLine: { lineStyle: { color: '#cdd7dd' } }, axisLabel: { color: '#7a8b94' } },
        yAxis: { type: 'value', splitLine: { lineStyle: { color: '#eef2f5' } }, axisLabel: { color: '#7a8b94' } },
        series: [{
          data, type: 'line', smooth: true, symbol: 'circle', symbolSize: 7,
          itemStyle: { color: '#00c2d6' },
          lineStyle: { width: 3, color: '#00c2d6' },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(0,229,255,.35)' },
              { offset: 1, color: 'rgba(0,255,163,.03)' }
            ])
          }
        }]
      })
      // 类型分布
      this.typeChart = echarts.init(this.$refs.typeChart)
      this.typeChart.setOption({
        tooltip: { trigger: 'item', backgroundColor: 'rgba(10,34,48,.9)', borderColor: '#1d5b73', textStyle: { color: '#fff' } },
        legend: { bottom: 0, textStyle: { color: '#7a8b94' } },
        color: ['#00e5ff', '#00ffa3', '#4f9bff'],
        series: [{
          type: 'pie', radius: ['45%', '70%'], center: ['50%', '45%'],
          avoidLabelOverlap: true,
          label: { color: '#1a2b33', formatter: '{b}\n{d}%' },
          labelLine: { length: 10, length2: 10 },
          data: [
            { value: 62, name: '直流快充' },
            { value: 28, name: '交流慢充' },
            { value: 10, name: '换电' }
          ]
        }]
      })
    }
  }
}
</script>

<style lang="less" scoped>
.welcome-dash {
  padding: 18px;
  background: #f0f3f6;
  min-height: 100%;

  // 横幅
  .welcome-hero {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 26px 30px;
    border-radius: 16px;
    margin-bottom: 18px;
    color: #fff;
    background: radial-gradient(900px 300px at 90% 10%, rgba(0, 255, 163, 0.18), transparent 60%),
      linear-gradient(120deg, #0d2740 0%, #0a1c2b 60%, #061a14 100%);
    box-shadow: 0 14px 30px rgba(10, 34, 48, 0.25);
    overflow: hidden;

    .hello {
      font-size: 16px;
      color: #9fe9d8;
      margin-bottom: 8px;
      .wave { display: inline-block; }
    }
    h1 {
      margin: 0;
      font-size: 26px;
      font-weight: 700;
      letter-spacing: 1px;
    }
    .date {
      margin: 10px 0 0;
      font-size: 13px;
      color: #8fb8c9;
    }
    .hero-pile .w-bolt {
      transform-origin: 100px 110px;
      animation: wBolt 1.8s ease-in-out infinite;
    }
    .hero-pile .w-bar {
      transform-origin: 66px 181px;
      animation: wBar 2.6s ease-in-out infinite;
    }
  }

  // KPI
  .kpi-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 14px;
    margin-bottom: 18px;
  }
  .kpi-card {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 18px;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 6px 18px rgba(20, 40, 60, 0.06);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 12px 26px rgba(20, 40, 60, 0.12);
    }
    .kpi-icon {
      width: 44px;
      height: 44px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
    }
    .kpi-body { flex: 1; min-width: 0; }
    .kpi-value {
      font-size: 22px;
      font-weight: 800;
      color: #0a2230;
      line-height: 1.1;
      .unit { font-size: 12px; font-weight: 600; color: #9aa9b2; margin-left: 2px; }
    }
    .kpi-label {
      margin-top: 4px;
      font-size: 13px;
      color: #7a8b94;
    }
    .kpi-trend {
      position: absolute;
      top: 12px;
      right: 14px;
      font-size: 12px;
      font-weight: 600;
      &.up { color: #00b894; }
      &.down { color: #e8504f; }
      .arrow { font-size: 10px; }
    }
  }

  // 面板
  .panel {
    background: #fff;
    border-radius: 14px;
    padding: 18px 20px;
    box-shadow: 0 6px 18px rgba(20, 40, 60, 0.06);
    margin-bottom: 18px;

    .panel-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        color: #0a2230;
        padding-left: 12px;
        position: relative;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 2px;
          bottom: 2px;
          width: 4px;
          border-radius: 4px;
          background: linear-gradient(180deg, #00e5ff, #00ffa3);
        }
      }
      .panel-sub { font-size: 12px; color: #9aa9b2; }
      .live {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #00b894;
        i {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #00ffa3;
          margin-right: 5px;
          box-shadow: 0 0 0 0 rgba(0, 255, 163, 0.6);
          animation: wLive 1.6s ease-out infinite;
        }
      }
    }
    .chart { width: 100%; height: 260px; }
    .chart-sm { height: 230px; }
  }

  // 底部双栏
  .bottom-row {
    display: grid;
    grid-template-columns: 1fr 1.3fr;
    gap: 18px;
  }

  // 排名
  .rank { padding-top: 4px; }
  .rank-item {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
    .rank-no {
      width: 22px;
      height: 22px;
      border-radius: 6px;
      text-align: center;
      line-height: 22px;
      font-size: 12px;
      font-weight: 700;
      color: #9aa9b2;
      background: #eef2f5;
      flex-shrink: 0;
      &.top { color: #fff; background: linear-gradient(135deg, #00c2d6, #00ffa3); }
    }
    .rank-name { width: 110px; font-size: 13px; color: #1a2b33; flex-shrink: 0; }
    .rank-track {
      flex: 1;
      height: 8px;
      border-radius: 8px;
      background: #eef2f5;
      overflow: hidden;
    }
    .rank-fill {
      height: 100%;
      border-radius: 8px;
      animation: wGrow 1s ease;
    }
    .rank-val { width: 48px; text-align: right; font-size: 13px; font-weight: 700; color: #0a2230; flex-shrink: 0; }
  }

  // 实时动态
  .feed { list-style: none; margin: 0; padding: 0; }
  .feed li {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 0;
    border-bottom: 1px dashed #eef2f5;
    &:last-child { border-bottom: none; }
    .feed-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
    .feed-text { flex: 1; font-size: 13px; color: #1a2b33; }
    .feed-time { font-size: 12px; color: #9aa9b2; flex-shrink: 0; }
  }
}

@keyframes wBolt { 0%, 100% { opacity: 0.75; } 50% { opacity: 1; } }
@keyframes wBar { 0% { width: 8px; } 50% { width: 42px; } 100% { width: 8px; } }
@keyframes wLive { 0% { box-shadow: 0 0 0 0 rgba(0, 255, 163, 0.6); } 100% { box-shadow: 0 0 0 8px rgba(0, 255, 163, 0); } }
@keyframes wGrow { from { width: 0 !important; } }
</style>



// WEBPACK FOOTER //
// src/views/Welcome.vue